function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useState, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { default as ReactAsync } from "react-select/async";
import { components } from "react-select";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import SearchIcon from "@mui/icons-material/Search";
import debounce from "lodash/debounce";
import UserAvatar from "../../../../components/mui/material/UserAvatar";
import { useThemeContext } from "../../../../contexts/ThemeContext";
import { fetchAiUsersByEnabledAtNotNullOrderByGroupMembersCountDesc, fetchUsersByUsernameStartingWithOrLastNameStartingWithAndUsernameNotInAndEnabledAtNotNull } from "../../../../actions";
import { brandPrimary } from "../../../../constants";
var tKey = "features.Chat.Messages.UsersAsync";
var customControlStyles = function customControlStyles(theme) {
  return {
    boxShadow: "none",
    border: "none",
    borderBottom: "1px solid ".concat(theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)"),
    borderRadius: 0,
    backgroundColor: theme === "dark" ? "black" : "white",
    "&:hover": {
      borderColor: theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)"
    }
  };
};
var customValueContainerStyles = {
  padding: "10px 10px 10px 16px"
};
var customInputStyles = {
  color: "inherit"
};
var customDropdownIndicatorStyle = {
  color: brandPrimary,
  padding: "18px 16px 18px 10px"
};
var customOptionStyle = function customOptionStyle(base, state, theme) {
  return {
    color: "inherit",
    backgroundColor: state.isFocused || state.isSelected ? "rgb(255, 255, 255, 0.08)" : base.backgroundColor,
    borderBottom: "1px solid ".concat(theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)"),
    padding: "16px 24px"
  };
};

// const customMultiValueStyle = {
//   backgroundColor: "rgba(255, 255, 255, 0.12)",
//   padding: 2,
//   borderRadius: 20,
// };

var customMenuStyle = function customMenuStyle(theme) {
  return {
    backgroundColor: theme === "dark" ? "black" : "white",
    margin: 0,
    padding: 0,
    borderRadius: 0
  };
};
var customMenuListStyle = {
  margin: 0,
  padding: 0,
  maxHeight: 440
};
var customStyle = function customStyle(theme) {
  return {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), customControlStyles(theme));
    },
    valueContainer: function valueContainer(base, state) {
      return _objectSpread(_objectSpread({}, base), customValueContainerStyles);
    },
    input: function input(base, state) {
      return _objectSpread(_objectSpread({}, base), customInputStyles);
    },
    dropdownIndicator: function dropdownIndicator(base, state) {
      return _objectSpread(_objectSpread({}, base), customDropdownIndicatorStyle);
    },
    option: function option(base, state) {
      return _objectSpread(_objectSpread({}, base), customOptionStyle(base, state, theme));
    },
    // multiValue: (base, state) => ({
    //   ...base,
    //   ...customMultiValueStyle,
    // }),
    menu: function menu(base, state) {
      return _objectSpread(_objectSpread({}, base), customMenuStyle(theme));
    },
    menuList: function menuList(base, state) {
      return _objectSpread(_objectSpread({}, base), customMenuListStyle);
    }
  };
};
var CustomDropdownIndicator = function CustomDropdownIndicator(props) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(SearchIcon, null));
};
var CustomOption = function CustomOption(props) {
  return /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0,
    paddingRight: 1
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    size: "md",
    user: props.data
  })), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 600
    }
  }, props.data.fullName), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "rgb(113, 118, 123)"
    }
  }, "@", props.data.username))));
};
var CustomMultiValue = function CustomMultiValue(props) {
  return /*#__PURE__*/React.createElement(components.MultiValueContainer, props, /*#__PURE__*/React.createElement(Chip, {
    avatar: /*#__PURE__*/React.createElement(UserAvatar, {
      size: "xs",
      user: props.data
    }),
    label: "@".concat(props.data.username),
    onDelete: props.removeProps.onClick
  }));
};
function UsersAsync(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useThemeContext = useThemeContext(),
    theme = _useThemeContext.theme,
    muiTheme = _useThemeContext.muiTheme;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var aiUsersCall = useSelector(function (state) {
    return state.apiCalls.fetchAiUsersByEnabledAtNotNullOrderByGroupMembersCountDesc["undefined"];
  }) || {};
  var usersCall = useSelector(function (state) {
    return state.apiCalls.loadUsersByUsernameStartingWithOrLastNameStartingWithAndUsernameNotInAndEnabledAtNotNull["undefined"];
  }) || {};
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    defaultOptions = _useState2[0],
    setDefaultOptions = _useState2[1];
  var loadOptionsCallback = useCallback(debounce(function (inputText, callback) {
    loadOptions(inputText).then(function (options) {
      return callback(options);
    });
  }, 1000), []);
  function handleNoOptionsMessage(_ref) {
    var inputValue = _ref.inputValue;
    if (inputValue === "") return t("".concat(tKey, ".placeholder"));
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "".concat(tKey, ".noOptions"),
      values: {
        inputValue: inputValue
      }
    });
  }
  function handleFocus() {
    dispatch(fetchAiUsersByEnabledAtNotNullOrderByGroupMembersCountDesc(0, 20)).then(function (action) {
      var _embedded = action.response._embedded;
      setDefaultOptions(_embedded ? _embedded.aiUsers.map(function (aiUser) {
        return _objectSpread({
          label: aiUser.username,
          value: aiUser.id
        }, aiUser);
      }) : []);
    });
  }
  function loadOptions(inputText) {
    return dispatch(fetchUsersByUsernameStartingWithOrLastNameStartingWithAndUsernameNotInAndEnabledAtNotNull(0, 10, inputText, inputText, authUser.username)).then(function (action) {
      var _embedded = action.response._embedded;
      var users = _embedded && _embedded.users || [];
      var aiUsers = _embedded && _embedded.aiUsers || [];
      return [].concat(_toConsumableArray(users), _toConsumableArray(aiUsers)).map(function (user) {
        return _objectSpread({
          label: user.username,
          value: user.id
        }, user);
      });
    });
  }
  return /*#__PURE__*/React.createElement(ReactAsync, _extends({
    isMulti: true,
    defaultOptions: defaultOptions,
    onFocus: handleFocus,
    isLoading: aiUsersCall.isFetching || usersCall.isFetching,
    loadOptions: loadOptionsCallback,
    loadingMessage: function loadingMessage() {
      return t("".concat(tKey, ".loadingMessage"));
    },
    noOptionsMessage: handleNoOptionsMessage,
    placeholder: t("".concat(tKey, ".placeholder"))
  }, props, {
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: CustomDropdownIndicator,
      Option: CustomOption,
      MultiValue: CustomMultiValue
    }, props.components),
    styles: _objectSpread(_objectSpread({}, customStyle(theme)), props.styles)
  }));
}
export default UsersAsync;